import EnrollmentTable from 'components/user/EnrollmentTable';
import GraduateCourseEnrollmentTable from 'components/user/GraduateCourseEnrollmentTable';
import { EditButton, Show } from '@refinedev/antd';
import { IUser } from 'interfaces/users';
import { PageHeader } from 'components/professor_area/PageHeader';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { Tabs, Tag, Typography } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { UserBonuses } from './components/show/UserBonuses';
import { UserDetails } from './components/show/UserDetails';
import { UserOrders } from './components/show/UserOrders';
import { UserPossessions } from './components/show/UserPossessions';
import { useCan, useShow } from '@refinedev/core';
import { useState } from 'react';

export const UserShow = () => {
  const canListOrders = useCan({ resource: 'orders', action: 'list' });
  const canShowCourseEnrollment = useCan({
    resource: 'course_enrollment',
    action: 'show'
  });
  const canShowGraduateEnrollment = useCan({
    resource: 'graduate_courses_enrollment',
    action: 'show'
  });
  const canListPossessions = useCan({
    resource: 'products/possessions',
    action: 'list'
  });
  const canListBonuses = useCan({
    resource: 'product_bonuses',
    action: 'list'
  });

  const { queryResult } = useShow<IUser>({
    errorNotification: {
      type: 'error',
      message: 'Erro ao carregar dados do usuário. Tente novamente!'
    }
  });
  const { data, isLoading } = queryResult;
  const userData = data?.data;
  const [activeTab, setActiveTab] = useState('info');

  if (!isLoading && !userData) {
    <Show isLoading={isLoading} title="Visualizar aluno">
      <Typography.Text>Nenhuma informação encontrada</Typography.Text>
    </Show>;
  }

  return (
    <ShowLayout
      isLoading={isLoading}
      title="Visualizar aluno"
      contentProps={{ className: '[&>div:bg-red-200' }}
    >
      <PageHeader
        title={userData?.name}
        icon={TeamOutlined}
        meta={<Tag>{userData?.email}</Tag>}
        actions={
          <EditButton
            id={userData?.id}
            type="primary"
            accessControl={{ hideIfUnauthorized: true }}
          >
            Editar
          </EditButton>
        }
      />

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        className="custom-tabs"
      >
        <Tabs.TabPane tab="Informações gerais" key="info">
          <UserDetails userData={userData!} />
        </Tabs.TabPane>
        {canListOrders.data?.can && (
          <Tabs.TabPane tab="Pedidos" key="orders">
            <UserOrders userData={userData!} />
          </Tabs.TabPane>
        )}
        {canShowCourseEnrollment.data?.can && userData?.id && (
          <Tabs.TabPane tab="Cursos Livres" key="free-enrollments">
            {activeTab === 'free-enrollments' && (
              <EnrollmentTable userId={userData.id} />
            )}
          </Tabs.TabPane>
        )}
        {canShowGraduateEnrollment.data?.can && userData?.id && (
          <Tabs.TabPane tab="Cursos Regulados" key="graduate-enrollments">
            {activeTab === 'graduate-enrollments' && (
              <GraduateCourseEnrollmentTable userId={userData.id} />
            )}
          </Tabs.TabPane>
        )}
        {canListPossessions.data?.can && (
          <Tabs.TabPane tab="Acessos" key="access">
            <UserPossessions userData={userData!} />
          </Tabs.TabPane>
        )}
        {canListBonuses.data?.can && (
          <Tabs.TabPane tab="Bônus" key="bonus">
            <UserBonuses userData={userData!} />
          </Tabs.TabPane>
        )}
      </Tabs>
    </ShowLayout>
  );
};
